import { Box, Button, CircularProgress, Typography } from '@mui/material'
import { useCallback } from 'react'
import { StartValidationIcon } from '../Svgs'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../../store'
import { createValidationTask } from '../../services/validationService'
import styled from '@emotion/styled'

const AnimatedBox = styled.div`
  border 2px solid transparent;
  border-radius: 4px;
  border: 1px solid transparent;
  background:
    linear-gradient(121deg, rgba(255, 255, 255, 0.47) 6.54%, rgba(255, 255, 255, 0) 100.86%) padding-box,
    linear-gradient(rgba(255, 255, 255, 1), rgba(255, 255, 255, 1)) padding-box,
    linear-gradient(
      var(--angle),
      rgba(23, 5, 229, 1),
      rgba(63, 105, 255, 1),
      rgba(149, 186, 237, 1),
      rgba(255, 59, 71, 1)
    ) border-box;
    box-shadow: 0px 2px 10px 0px rgb(250, 251, 251);
    backdrop-filter: blur(24.56999969482422px);
    animation: 16s rotate linear infinite;

    width: 11%;
    height: 20%;
    padding: 8px 24px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 2px;

    @keyframes rotate {
      to {
        --angle: 360deg;
      } 
    }

    @property --angle {
      syntax: '<angle>';
      initial-value: 0deg;
      inherits: false;
    }
`

const StartValidationModal = () => {
  const dispatch = useDispatch<any>()

  const isCodeValidationProcessingStarted = useSelector(
    (state: RootState) => state.validation.isCodeValidationProcessingStarted,
  )

  const onStartValidationClick = useCallback(() => {
    dispatch(createValidationTask())
  }, [dispatch])

  return (
    <AnimatedBox>
      <svg
        width='22'
        height='24'
        viewBox='0 0 34 36'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <path
          d='M18.6075 1.28655C17.6678 0.534456 16.3322 0.534457 15.3925 1.28656L0.965139 12.8331C0.355097 13.3213 0 14.0604 0 14.8417V33.2168C0 34.6376 1.15183 35.7895 2.57268 35.7895H31.4273C32.8482 35.7895 34 34.6376 34 33.2168V14.8417C34 14.0604 33.6449 13.3213 33.0349 12.8331L18.6075 1.28655Z'
          fill='url(#paint0_linear_5601_31526)'
        />
        <path
          d='M16.3975 31.0095C16.7455 31.0095 16.9941 30.7763 17.0439 30.3932C17.5743 25.8955 17.7897 25.7622 22.3477 25.0459C22.7621 24.9793 23.0107 24.7627 23.0107 24.3962C23.0107 24.0464 22.7621 23.8132 22.4306 23.7466C17.8063 22.847 17.5743 22.8803 17.0439 18.3993C16.9941 18.0162 16.7455 17.783 16.3975 17.783C16.0494 17.783 15.8008 18.0162 15.751 18.3827C15.1875 22.947 15.0218 23.1136 10.3809 23.7466C10.0494 23.7799 9.78418 24.0464 9.78418 24.3962C9.78418 24.7461 10.0328 24.9793 10.3643 25.0459C15.0383 25.9454 15.1709 25.9454 15.751 30.4265C15.8008 30.7763 16.0494 31.0095 16.3975 31.0095Z'
          fill='white'
        />
        <path
          d='M11.1101 19.1061C11.3189 19.1061 11.4681 18.9662 11.4979 18.7363C11.8161 16.0377 11.9454 15.9577 14.6802 15.5279C14.9288 15.4879 15.078 15.358 15.078 15.1381C15.078 14.9282 14.9288 14.7883 14.7299 14.7483C11.9554 14.2086 11.8161 14.2286 11.4979 11.54C11.4681 11.3101 11.3189 11.1702 11.1101 11.1702C10.9012 11.1702 10.752 11.3101 10.7222 11.53C10.3841 14.2686 10.2846 14.3685 7.5001 14.7483C7.30121 14.7683 7.14209 14.9282 7.14209 15.1381C7.14209 15.348 7.29126 15.4879 7.49016 15.5279C10.2946 16.0677 10.3741 16.0677 10.7222 18.7563C10.752 18.9662 10.9012 19.1061 11.1101 19.1061Z'
          fill='white'
        />
        <path
          d='M23.0115 21.7527C23.1507 21.7527 23.2502 21.6594 23.2701 21.5061C23.4822 19.707 23.5684 19.6537 25.3916 19.3672C25.5574 19.3406 25.6568 19.2539 25.6568 19.1073C25.6568 18.9674 25.5574 18.8741 25.4248 18.8475C23.5751 18.4877 23.4822 18.501 23.2701 16.7086C23.2502 16.5553 23.1507 16.462 23.0115 16.462C22.8723 16.462 22.7728 16.5553 22.753 16.7019C22.5275 18.5276 22.4612 18.5943 20.6049 18.8475C20.4723 18.8608 20.3662 18.9674 20.3662 19.1073C20.3662 19.2473 20.4657 19.3406 20.5983 19.3672C22.4679 19.727 22.5209 19.727 22.753 21.5194C22.7728 21.6594 22.8723 21.7527 23.0115 21.7527Z'
          fill='white'
        />
        <defs>
          <linearGradient
            id='paint0_linear_5601_31526'
            x1='26.8421'
            y1='8.05263'
            x2='7.15789'
            y2='41.1579'
            gradientUnits='userSpaceOnUse'
          >
            <stop stopColor='#06004A' />
            <stop offset='0.43' stopColor='#3D8BFF' />
            <stop offset='0.755' stopColor='#8CBAFF' />
          </linearGradient>
        </defs>
      </svg>

      <Typography
        sx={{
          color: '#06004A',
          fontSize: '22px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: 'normal',
        }}
      >
        Start Validation
      </Typography>
      <Typography
        sx={{
          color: '#797979',
          fontSize: '10px',
          fontStyle: 'normal',
          fontWeight: 500,
          lineHeight: 'normal',
        }}
      >
        Run thousands of validations on your model simultaneously
      </Typography>
      <Button
        disableElevation
        variant='contained'
        onClick={onStartValidationClick}
        disabled={isCodeValidationProcessingStarted}
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '8px',
          borderRadius: '6px',
          backgroundColor: '#1705E5',
          marginTop: '8px',
          backgroundFilter: 'blur(24.56999969482422px)',
          padding: '4px 6px',
          '&.Mui-disabled': {
            backgroundColor: '#1705E5',
          },
        }}
      >
        {isCodeValidationProcessingStarted ? (
          <CircularProgress
            style={{
              width: '19px',
              height: '19px',
            }}
            sx={{
              color: '#FFF',
            }}
          />
        ) : (
          <>
            <StartValidationIcon />

            <Typography
              sx={{
                color: '#FFF',
                fontSize: '8px',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: 'normal',
                textTransform: 'none',
              }}
            >
              Start Validation
            </Typography>
          </>
        )}
      </Button>
    </AnimatedBox>
  )
}

export default StartValidationModal
